// Tabs for a policy page whose text (Settings > Policies) is split into
// <div class="tc-tabs"> … <div class="tc-panel"> blocks, e.g. Terms of service.
// Shopify does not keep <input>/<label> in policy text, so the tab bar is built
// here from the first heading of each panel. Without this script the panels
// simply show one after another.
// A link can open a tab: #tab-3, or words from its title (#rewards, #online-sale).
// Loaded right after the page content (layout/theme.liquid), so it runs at once.
(() => {
  const slugify = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const initTabs = (root, rootIndex) => {
    const panels = [...root.querySelectorAll('.tc-panel')];
    if (panels.length < 2) return;

    let list = root.querySelector('.tc-tabs__labels');
    if (!list) {
      list = document.createElement('div');
      list.className = 'tc-tabs__labels';
      root.prepend(list);
    }
    list.textContent = '';
    list.setAttribute('role', 'tablist');

    const tabs = panels.map((panel, i) => {
      const heading = panel.querySelector('h1, h2, h3');
      const title = heading ? heading.textContent.trim() : `Part ${i + 1}`;
      const tab = document.createElement('button');

      tab.type = 'button';
      tab.className = 'tc-tabs__tab';
      tab.id = `tc-tab-${rootIndex + 1}-${i + 1}`;
      tab.textContent = title;
      tab.dataset.title = title;
      tab.dataset.slug = slugify(title);
      tab.setAttribute('role', 'tab');

      panel.id = panel.id || `tc-panel-${rootIndex + 1}-${i + 1}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-controls', panel.id);

      list.append(tab);
      return tab;
    });

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
      });

      // On narrow screens the bar scrolls sideways: keep the selected tab in view.
      const tab = tabs[index];
      list.scrollLeft = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
      if (focus) tab.focus();
    };

    const indexFromHash = () => {
      const hash = window.location.hash.slice(1).toLowerCase();
      if (!hash) return -1;

      const number = hash.match(/^tab-(\d+)$/);
      if (number) return number[1] > tabs.length ? -1 : number[1] - 1;

      return tabs.findIndex((tab) => `-${tab.dataset.slug}-`.includes(`-${hash}-`));
    };

    list.addEventListener('click', (event) => {
      const index = tabs.indexOf(event.target.closest('.tc-tabs__tab'));
      if (index > -1) select(index);
    });

    list.addEventListener('keydown', (event) => {
      const current = tabs.indexOf(document.activeElement);
      const next = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: tabs.length - 1 }[event.key];
      if (current === -1 || next === undefined) return;

      event.preventDefault();
      select((next + tabs.length) % tabs.length, true);
    });

    window.addEventListener('hashchange', () => {
      const index = indexFromHash();
      if (index > -1) select(index);
    });

    root.classList.add('tc-tabs--ready');
    select(Math.max(indexFromHash(), 0));
  };

  document.querySelectorAll('.shopify-policy__body .tc-tabs').forEach(initTabs);
})();
